// extracted by mini-css-extract-plugin
module.exports = {"inlineLink":"StoreAvailabilityInlineLink_inlineLink___COz7","selectedLabel":"StoreAvailabilityInlineLink_selectedLabel__pnnp6","link":"StoreAvailabilityInlineLink_link__OmVLi"};